import { useEffect, useState } from 'react';
import { onSpeaking } from './voice';

// "Asha", the demo guide: an AI-generated photo of a fictional person (not a real individual).
// While she speaks, a soft ring pulses and sound bars move.
export function GuideAvatar({ size = 64 }: { size?: number }) {
  const [talking, setTalking] = useState(false);
  useEffect(() => onSpeaking(setTalking), []);
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid="tour-avatar">
      <span className={`absolute inset-0 rounded-full ${talking ? 'guide-ring' : ''}`} aria-hidden="true" />
      <span className="relative block h-full w-full overflow-hidden rounded-full border-2 border-white bg-sc-soft">
        {/* Zoom in on the face so it reads clearly at small sizes. */}
        <img src="/guide/asha-pro.jpg" alt="Asha" width={size} height={size} className="h-full w-full object-cover" style={{ transform: 'scale(1.6)', transformOrigin: '33% 30%' }} />
      </span>
      {talking && (
        <span className="absolute -bottom-1 -right-1 flex h-5 items-end gap-[2px] rounded-full bg-white px-1.5 py-1" aria-hidden="true">
          <i className="guide-bar" /><i className="guide-bar" /><i className="guide-bar" />
        </span>
      )}
    </div>
  );
}
